<template>
  <v-dialog
    v-model="localDialog"
    width="80%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
  >
    <v-card>
      <v-card-title class="text-h6">
        {{ isEntryMode ? "Add Payment" : "Update Payment" }}
      </v-card-title>

      <v-form @submit.prevent="submit">
        <v-divider></v-divider>

        <v-card-text class="pa-0 pa-9">
          <!-- Author Basic Information -->
          <v-row>
            <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-date-input
                prepend-icon=""
                prepend-inner-icon="mdi-calendar"
                v-model="date_of_enroll.value.value"
                label="Payment Date"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                :error-messages="date_of_enroll.errorMessage.value"
                autocomplete="off"
              ></v-date-input>
            </v-col>

            <!-- <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-text-field
                v-model="order_number.value.value"
                label="Order Number"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                :error-messages="order_number.errorMessage.value"
                 autocomplete="off"
              ></v-text-field>
            </v-col> -->

            <!-- <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-text-field
                v-model="name.value.value"
                label="Name"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                :error-messages="name.errorMessage.value"
                 autocomplete="off"
              ></v-text-field>
            </v-col> -->

            <!-- <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-text-field
                v-model="phone.value.value"
                label="Phone"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                :error-messages="phone.errorMessage.value"
                 autocomplete="off"
              ></v-text-field>
            </v-col> -->

            <!-- <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-text-field
                v-model="email.value.value"
                label="Email"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                :error-messages="email.errorMessage.value"
                autocomplete="off"
              />
            </v-col> -->

            <!-- <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-autocomplete
                v-model="payment_method.value.value"
                :items="paymentMethods"
                :item-title="(item) => item.display_text"
                item-value="name"
                label="Payment Method"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                @update:modelValue="onChangePaymentMethod"
                :error-messages="payment_method.errorMessage.value"
                autocomplete="off"
              />
            </v-col> -->

             

            <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-select 
                  variant="outlined" 
                  density="compact"
                  bg-color="grey-lighten-4"
                  v-model="payment_type.value.value" 
                  :items="paymentTypes"
                  :item-title="(item) => `${item.label}`"
                  item-value="value" 
                  :error-messages="payment_type.errorMessage.value"
                  @update:modelValue="onPaymentTypeChange"
                  autocomplete="off"
                >
                  <template #label>
                    Payment Method
                    <span class="text-red-accent-4">*</span>
                  </template>
                </v-select>
            </v-col>

            <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-select 
                label="Account No"
                variant="outlined" 
                density="compact"
                bg-color="grey-lighten-4"
                v-model="payment_acc_head.value.value"
                :items="getPaymentAccountHeadList"
                :item-title="(item) => `${item.name}`"
                item-value="id" 
                :error-messages="payment_acc_head.errorMessage.value"
                autocomplete="off"
              />
            </v-col>

            <v-col v-if="payment_type.value.value === 'BANK'" cols="12" sm="3" class="pr-4 pa-0">
              <v-text-field 
                label="Cheque No"
                density="compact"
                type="number"
                variant="outlined" 
                bg-color="grey-lighten-4"
                v-model="chequeNo.value.value"
                hide-details="auto"
                :error-messages="chequeNo.errorMessage.value"
                autocomplete="off" 
              />
            </v-col>

            <v-col v-if="payment_type.value.value === 'BANK'" cols="12" sm="3" class="pr-4 pa-0">
              <v-date-input 
                  label="Cheque Issue Date"
                  density="compact"
                  bg-color="grey-lighten-4"
                  prepend-icon="" 
                  prepend-inner-icon="mdi-calendar"
                  v-model="cheque_issue_date.value.value" 
                  variant="outlined"
                  hide-details="auto"
                  :error-messages="cheque_issue_date.errorMessage.value"
                  autocomplete="off"
              ></v-date-input>
            </v-col>

            <v-col v-if="payment_type.value.value === 'MOBILE_BANKING'" cols="12" sm="3" class="pr-4 pa-0">
              <v-autocomplete 
                density="compact" 
                variant="outlined"
                bg-color="grey-lighten-4"
                label="Provider"
                v-model="mobileProvider.value.value"
                :items="mobileProviders"
                item-title="label"
                item-value="value" 
                hide-details="auto"
                :error-messages="mobileProvider.errorMessage.value"
                autocomplete="off"
              >
              </v-autocomplete>
            </v-col>

            <v-col v-if="payment_type.value.value === 'MOBILE_BANKING'" cols="12" sm="3" class="pr-4 pa-0">
              <v-text-field
                density="compact"
                variant="outlined" 
                bg-color="grey-lighten-4"
                label="Transaction ID"
                v-model="transactionId.value.value"
                hide-details="auto"
                :error-messages="transactionId.errorMessage.value"
                autocomplete="off" 
              />
            </v-col>

            <!-- <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-autocomplete
                v-model="contacted_by_id.value.value"
                :items="getContactList"
                :item-title="(item) => item.name"
                item-value="id"
                label="Contacted By"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                clearable
                :error-messages="contacted_by_id.errorMessage.value"
                autocomplete="off"
              ></v-autocomplete>
            </v-col> -->

            <!-- <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-autocomplete
              v-model="author_type_id.value.value"
                :items="getAuthorList"
                :item-title="(item) => item.name"
                item-value="id"
                label="Author Type"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                clearable
                :error-messages="author_type_id.errorMessage.value"
                autocomplete="off"
              ></v-autocomplete>
            </v-col> -->

            <!-- <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-text-field
                v-model="install_ments.value.value"
                label="Total Installment"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                type="number"
                hide-details
                clearable
                :max="10"
                :min="0"
                :disabled = "payment_method.value.value !== 'installment'"
                @update:modelValue="addpayments"
                :error-messages="install_ments.errorMessage.value"
                autocomplete="off"
              />
            </v-col> -->

            <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-text-field
                v-model="agreed_amount.value.value"
                label="Agreed Value"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                type="number"
                clearable
                disabled
                @update:modelValue="compareAmounts"
                :error-messages="agreed_amount.errorMessage.value"
                autocomplete="off"
              />
            </v-col>

             <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-text-field
                v-model="paid_amount.value.value"
                label="Paid Amount"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                type="number"
                clearable
                disabled
                @update:modelValue="compareAmounts"
                :error-messages="paid_amount.errorMessage.value"
                autocomplete="off"
              />
            </v-col>

            <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-text-field
                v-model="due_amount.value.value"
                label="Due Amount"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                disabled
                :model-value="Number(agreed_amount.value?.value || 0) - Number(paid_amount.value?.value || 0) - Number(receive_amount.value?.value || 0)"
                :error-messages="due_amount.errorMessage.value"
                autocomplete="off"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-text-field
                v-model="receive_amount.value.value"
                label="Receive Amount"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                type="number"
                clearable
                @update:modelValue="compareAmounts"
                :error-messages="receive_amount.errorMessage.value"
                autocomplete="off"
              />
            </v-col>

            <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-date-input
                prepend-icon=""
                prepend-inner-icon="mdi-calendar"
                v-model="next_payment_date.value.value"
                label="Next Payment Date"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                :error-messages="next_payment_date.errorMessage.value"
                autocomplete="off"
              ></v-date-input>
            </v-col>

            <v-col cols="12" sm="3" class="pr-4 pa-0">
              <v-textarea
                rows="2"
                v-model="bio.value.value"
                label="Notes"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                class="ma-0"
                :error-messages="bio.errorMessage.value"
                autocomplete="off"
                clearable
              />
            </v-col>
          </v-row>

          <input v-model="array_index.value.value" type="hidden">

          <!-- Payment payments -->
          <!-- <v-row>
            <v-col cols="12">
              <v-table density="comfortable" class="pa-2 elevation-1 rounded-lg" hover>
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Amount</th>
                    <th>Proposed Date</th>
                    <th>Changed Date</th>
                    <th>Recive Amount</th>
                    <th>Recive Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in payments" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ $numberFormat(item.amount) }}</td>
                    <td>
                        <v-date-input
                          label=""
                          style="margin-top:8px;width:180px"
                          v-model="item.payment_date"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          density="compact"
                          bg-color="grey-lighten-4"
                          autocomplete="off"
                          clearable
                        />
                    </td>
                    <td class="mt-3">
                        <v-date-input
                          label=""
                          style="margin-top:8px;width:180px"
                          v-model="item.change_date"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          density="compact"
                          bg-color="grey-lighten-4"
                          autocomplete="off"
                          clearable
                        />
                    </td>
                    <td>
                        <v-text-field
                          label=""
                          width="100px"
                          style="margin-top:8px;width:180px"
                          v-model="item.recive_amount"
                          type="number"
                          density="compact"
                          bg-color="grey-lighten-4"
                          @input="validateReciveAmount(item)"
                        />
                    </td>
                    <td>
                        <v-date-input
                          label=""
                          v-model="item.recive_date"
                          style="margin-top:8px;width:180px"
                          prepend-icon=""
                          prepend-inner-icon="mdi-calendar"
                          density="compact"
                          bg-color="grey-lighten-4"
                        />
                    </td>
                  </tr>
                  
                  <tr v-if="!payments.length">
                    <td colspan="7" class="text-center">
                      <h3>No Schedule added</h3>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="text-right font-weight-bold">
                      Total:
                    </td>
                    <td class="font-weight-bold">
                      {{ $numberFormat(getTotalPaymentAmount) }}
                    </td>
                    <td class="text-right font-weight-bold">
                      Recived Amount:
                    </td>
                    <td class="font-weight-bold">
                      {{ $numberFormat(getTotalReciveAmount) }}
                    </td>
                    <td class="text-right font-weight-bold">
                      Due Amount:
                    </td>
                    <td class="font-weight-bold">
                      {{ $numberFormat(getDueAmount) }}
                    </td>
                  </tr>
                </tfoot>
              </v-table>
            </v-col>
          </v-row> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout class="justify-end">
            <v-btn
              class="bg-red"
              variant="flat"
              type="reset"
              @click="closeDialog"
              >Close</v-btn
            >
            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
              {{ isEntryMode ? "Save" : "Update" }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { getCurrentInstance, ref, computed } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  name: "SalesOrderSetup",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({
        agreed_amount: "",
        name: "",
        receive_amount: null,
        paid_amount: null,
        due_amount: null,
        author_type_id: null,
        contacted_by_id: null,
        date_of_enroll: null,
        email: null,
        install_ments: null,
        // payment_method: null,
        payment_type: null,
        phone: null,
        bio: "",
        payments: [],
        sale_order_id: null,
      }),
    },
  },

  data() {
    return {
      localDialog: this.dialog,
      isEntryMode: true,
      contactErrors: {},

      paymentMethods: [
        { id: 1, name: "one_time", display_text: "One Time" },
        { id: 3, name: "installment", display_text: "Installment" },
      ],

      paymentTypes: [
        { label: "Cash", value: "CASH" },
        { label: "Bank", value: "BANK" },
        { label: "Mobile Banking", value: "MOBILE_BANKING" }
      ],
      mobileProviders: [ 
        { label: "Bkash", value: "bkash" },
        { label: "Nagad", value: "nagad" },
        { label: "Rocket", value: "rocket" }
      ],
      payment_installment_sl: 0,
      // editPaymentIndex: null,
      // editPayment: {
      //   amount: "",
      //   payment_date: "",
      //   change_date: "",
      //   recive_amount: "",
      //   recive_date: "",
      //   reminder: false,
      // },
    };
  },

  watch: {
    payment_type() {
      this.onPaymentTypeChange();
    },
    dialog(newVal) {
      this.localDialog = newVal;
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.receive_amount.setValue(newData.receive_amount || 0, false);
        // this.name.setValue(newData.name || "", false);
        if(!newData.id) {
          this.agreed_amount.setValue(newData.amount || 0, false);
          this.paid_amount.setValue(newData.paid || 0, false);
        } else {
          this.agreed_amount.setValue(newData.agreed_amount || "", false);
          this.paid_amount.setValue(newData.paid_amount || 0, false);
        }
        // this.author_type_id.setValue(newData.author_type_id || "", false);
        this.bio.setValue(newData.bio || "", false);
        // this.contacted_by_id.setValue(newData.contacted_by_id || "", false);
        this.date_of_enroll.setValue(newData.date_of_enroll || new Date(), false);
        this.next_payment_date.setValue(newData.next_payment_date || null, false);
        this.due_amount.setValue(newData.due_amount || "", false);
        // this.email.setValue(newData.email || "", false);
        this.install_ments.setValue(newData.install_ments || "", false);
        this.payment_type.setValue(newData.payment_type || "", false);
        // this.payment_method.setValue(newData.payment_method || "", false);
        // this.phone.setValue(newData.phone || "", false);
        // this.sale_order_id.setValue(newData.id || "", false);
        this.payments = newData.payments || [];
        this.array_index.setValue(newData.arrIndex);
        this.payment_acc_head.setValue(newData.payment_acc_head || "");
        this.chequeNo.setValue(newData.chequeNo || "");
        this.cheque_issue_date.setValue(newData.cheque_issue_date || null);
        this.mobileProvider.setValue(newData.mobileProvider || "");
        this.transactionId.setValue(newData.transactionId || "");
      },
    },
  },

  created() {
    if (this.$store.getters.getAuthorList.length === 0) {
      this.$store.dispatch("getAuthorList");
    }
    if (this.$store.getters.getContactList.length === 0) {
      this.$store.dispatch("getContactList");
    }
  },

  computed: {
    getAuthorList() {
      return this.$store.getters.getAuthorList;
    },
    getContactList() {
      return this.$store.getters.getContactList;
    },
    getTotalPaymentAmount() {
      return this.payments.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
      );
    },
    getTotalReciveAmount() {
      return this.payments.reduce(
        (sum, item) => sum + Number(item.recive_amount || 0),
        0
      );
    },
    getDueAmount() {
      return this.getTotalPaymentAmount - this.getTotalReciveAmount;
    },

    getPaymentAccountHeadList() {
      return this.$store.getters.getPaymentAccountHeadList;
    },
    // authorTypeName() {
    //   const selectedId = this.author_type_id.value.value;
    //   const selectedAuthor = this.getAuthorList.find(a => a.id === selectedId);
    //   return selectedAuthor ? selectedAuthor.name : '';
    // },
    // contactedByName() {
    //   const selectedId = this.contacted_by_id.value.value;
    //   const selectedContact = this.getContactList.find(c => c.id === selectedId);
    //   return selectedContact ? selectedContact.name : '';
    // }
  },

  methods: {
    formattedDate,

    updateDialog(value) {
      this.$emit("update:dialog", value);
    },

    closeDialog() {
      this.updateDialog(false);
    },

    async onPaymentTypeChange() {
      if (this.payment_type.value.value) {
        await this.$store.dispatch("getPaymentAccountHeadList", { type: this.payment_type.value.value });
        this.payment_acc_head.value.value = null;
      }
    },

    // onChangePaymentMethod() {
    //   const agreed = Number(this.agreed_amount.value.value || 0);
      
    //   if (this.payment_type.value.value === "one_time") {
    //     this.install_ments.setValue(0);
    //     this.payments = [];
    //     this.paid_amount.value.value = this.agreed_amount.value.value || 0;
    //     this.due_amount.value.value = 0;
    //   } else {
    //     this.install_ments.setValue(1);
    //     this.paid_amount.setValue(0);
    //     this.due_amount.setValue(agreed);
    //     this.payments = [];
    //   }
    //   this.addpayments();
    // },

    compareAmounts() {
      const agreed = Number(this.agreed_amount.value.value || 0);
      const receive = Number(this.receive_amount.value.value || 0);
      const paid = Number(this.paid_amount.value.value || 0);
      if ((+paid + +receive) > agreed) {
        // toast.error("Paid amount cannot be greater than agreed amount");
        this.receive_amount.setValue(0);
        this.due_amount.setValue(agreed);
      } else {
        this.due_amount.setValue(+agreed - (+paid + +receive));
      }

      // if (this.payment_method.value.value === "one_time") {
      //   this.install_ments.setValue(0);
      //   this.payments = [];
      //   this.paid_amount.value.value = this.agreed_amount.value.value || 0;
      //   this.due_amount.value.value = 0;
      // }

      // if (this.payment_method.value.value === "installment") {
      //   const due = Number(this.due_amount.value.value || 0);
      //   if (due <= 0) {
      //     this.install_ments.setValue(0);
      //     this.payments = [];
      //   } else {
      //     this.addpayments();
      //   }
      // }

    },

    validateReciveAmount(item) {
      const planned = Number(item.amount || 0);
      let received = Number(item.recive_amount || 0);

      if (received > planned) {
        // Prevent exceeding
        item.recive_amount = planned;
      } else if (received < 0) {
        item.recive_amount = 0; // optional: prevent negative
      }
    },

    addpayments() {
      if (!this.install_ments.value.value || this.install_ments.value.value < 0 || this.install_ments.value.value > 10) {
        if(this.payment_method.value.value === "one_time") {
          this.install_ments.setValue(0);

        } else {
          this.install_ments.setValue(1);
        }
      }

      const totalInstallments = Number(this.install_ments.value.value || 0);
      const due = Number(this.due_amount.value.value || 0);

      if (totalInstallments <= 0) {
        this.payments = [];
        return;
      }
      
      const installmentAmount = parseFloat((due / totalInstallments).toFixed(2));

      this.payments = []
       for (let index = 0; index < this.install_ments.value.value; index++) {
        const item = {
          amount: installmentAmount,
          payment_date: null,
          change_date: null,
          recive_amount: null,
          recive_date: null,
          reminder: true,
        };
        this.payments.push(item);
      }
    },
  },

  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        // name: yup.string().min(1).max(50).nullable().trim().label("Author Name"),
        date_of_enroll: yup.string().required().label("Date of Enroll"),
        //next_payment_date: yup.string().required().label("Next Payment Date"),
        // phone: yup.string().min(8).max(15).required().label("Phone"),
        // email: yup.string().email().nullable().label("Email"),
        payment_type: yup.string().required().label("Payment Type"),
        // payment_method: yup.string().required().label("Payment Method"),
        // contacted_by_id: yup.string().required().label("Contacted By"),
        // install_ments: yup.string().nullable(),
        // author_type_id: yup.string().required(),
        receive_amount: yup.string().required(),
        agreed_amount: yup.string().required(),
        paid_amount: yup.string().required(),
        due_amount: yup.string().nullable(),
        payment_acc_head: yup.number().required().label("Payment Account Head"),
        chequeNo: yup.string().nullable().when("payment_type", { is: "BANK", then: (schema) => schema.required("Cheque No is required"),  otherwise: (schema) => schema.nullable(),}),
        cheque_issue_date: yup.date().nullable().when("payment_type", { is: "BANK", then: (schema) => schema.required("Cheque Issue Date is required"),  otherwise: (schema) => schema.nullable(),}),
        mobileProvider: yup.string().nullable().when("payment_type", { is: "MOBILE_BANKING", then: (schema) => schema.required("Provider is required"),  otherwise: (schema) => schema.nullable(),}),
        transactionId: yup.string().nullable().when("payment_type", { is: "MOBILE_BANKING",  then: (schema) => schema.required("Transaction ID is required"), otherwise: (schema) => schema.nullable(),}),
        bio: yup.string().nullable(),
        amount: yup.string().nullable(),
        payment_date: yup.string().nullable(),
        // change_date: yup.string().nullable(),
        // reminder: yup.string().nullable()
      }),
    });

    // Define fields
    const date_of_enroll = useField("date_of_enroll");
    const next_payment_date = useField("next_payment_date");
    // const name = useField("name");
    // const phone = useField("phone");
    // const email = useField("email");
    const payment_type = useField("payment_type");
    // const payment_method = useField("payment_method");
    const payment_acc_head = useField("payment_acc_head");
    const chequeNo = useField("chequeNo");
    const cheque_issue_date = useField("cheque_issue_date");
    const transactionId = useField("transactionId");
    const mobileProvider = useField("mobileProvider");
    // const contacted_by_id = useField("contacted_by_id");
    const install_ments = useField("install_ments");
    // const author_type_id = useField("author_type_id");
    const receive_amount = useField("receive_amount");
    const agreed_amount = useField("agreed_amount");
    const paid_amount = useField("paid_amount");
    const due_amount = useField("due_amount");
    const bio = useField("bio");

    const amount = useField("amount");
    const payment_date = useField("payment_date");
    const change_date = useField("change_date");
    const recive_amount = useField("recive_amount");
    const recive_date = useField("recive_date");
    // const reminder = useField("reminder");
    const array_index = useField("array_index");

    // const authorTypeName = computed(() => {
    //   const selectedId = author_type_id.value.value;
    //   const selectedAuthor = proxy.getAuthorList.find(a => a.id === selectedId);
    //   return selectedAuthor ? selectedAuthor.name : '';
    // });

    // const contactedByName = computed(() => {
    //   const selectedId = contacted_by_id.value.value;
    //   const selectedContact = proxy.getContactList.find(c => c.id === selectedId);
    //   return selectedContact ? selectedContact.name : '';
    // });

    const payments = ref([]);

    const sale_order_id = useField("sale_order_id");

    const store = useStore();
    const loading = ref(false);

    const submit = handleSubmit((values) => {

      const formData = {
        ...values,
        date_of_enroll: formattedDate(values.date_of_enroll),
        next_payment_date: formattedDate(values.next_payment_date),
        cheque_issue_date: formattedDate(values.cheque_issue_date),
        payment_date: formattedDate(values.payment_date),
        change_date: formattedDate(values.change_date),
        recive_date: formattedDate(values.recive_date),
        payments: proxy.payments.map(item => ({
          ...item,
          payment_date: formattedDate(item.payment_date),
          change_date: formattedDate(item.change_date),
          recive_date: formattedDate(item.recive_date),
        })),
    };

    store
      .dispatch("saveProjectPayment", formData)
      .then((response) => {
        resetForm();
        emit("update:dialog", false);
        emit("update-success");
        toast.success(response.data.message);
        loading.value = true;
        Promise.all([
          store.dispatch("getProjectList"),
        ]).finally(() => {
          loading.value = false;
        });
      })
      .catch((error) => {
        console.log(error.response)
        toast.error(error.response?.data?.message);
      });

      emit("save-author", formData);  
      emit("update:dialog", false);
      resetForm();
    });

    return {
      date_of_enroll,
      next_payment_date,
      // name,
      // phone,
      // email,
      payment_type,
      // payment_method,
      // contacted_by_id,
      install_ments,
      // author_type_id,
      receive_amount,
      agreed_amount,
      paid_amount,
      due_amount,
      amount,
      payment_date,
      change_date,
      payment_acc_head,
      chequeNo,
      cheque_issue_date,
      transactionId,
      mobileProvider,
      recive_amount,
      recive_date,
      // reminder,
      bio,
      store,
      payments,
      array_index,
      sale_order_id,
      loading,
      submit,
      resetForm,
    };
  },

  mounted() {
    // this.onPaymentTypeChange();
  },
};
</script>
